import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CommunityComponent } from '../community/community.component';
import { SupportComponent } from '../support/support.component';
import { HomeComponent } from '../home/home.component';
import {GmapComponent} from '../gmap/gmap.component';
import { LoginComponent } from '../login/login.component';
export const router2: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
     { path: 'login', component: LoginComponent },
    //  { path: 'home', component: HomeComponent },
    // { path: 'community', component: CommunityComponent },
    // { path: 'support', component: SupportComponent },
    // { path: 'gmap', component: GmapComponent }
];

export const routes2: ModuleWithProviders = RouterModule.forRoot(router2);


// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/dash/dash.router.ts